export const generateLocalBusinessSchema = (city?: string) => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "elektraaanleggen.nl",
  image: "https://elektraaanleggen.nl/images/banner.png",
  description: city
    ? `Uw betrouwbare elektricien voor alle elektrotechnische werkzaamheden in ${city}. Van groepenkast tot laadpaal, wij zorgen voor een veilige en moderne installatie.`
    : "Uw betrouwbare elektricien voor alle elektrotechnische werkzaamheden. Specialist in elektra aanleg, renovatie en onderhoud. Vakkundig en veilig.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Laan van Vollenhove 2935",
    addressLocality: "Zeist",
    postalCode: "3706 AK",
    addressCountry: "NL",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 52.2292,
    longitude: 5.1669,
  },
  url: "https://elektraaanleggen.nl",
  email: "info@elektraaanleggen.nl",
  telephone: "+31852129778",
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "07:00",
      closes: "18:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Saturday"],
      opens: "12:00",
      closes: "17:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Sunday"],
      opens: "closed",
      closes: "closed",
    },
  ],
});

export const generateServiceSchema = (service: {
  name: string;
  description: string;
  image: string;
  city?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: service.name,
  description: service.city
    ? `${service.description} Beschikbaar in ${service.city} en omgeving.`
    : service.description,
  image: service.image,
  provider: {
    "@type": "LocalBusiness",
    name: "elektraaanleggen.nl",
  },
  areaServed: service.city || "NL",
});
